import React from 'react'

import { Icon, UploadAreaUI } from '@fourthwall/components'
import { PlusIcon } from '@fourthwall/icons'

import * as S from './styled'

type EmptyStateUploadZoneProps = {
  accepted: boolean
  rejected: boolean
  active: boolean
  open?: () => void
}

const EmptyStateUploadZone = (props: EmptyStateUploadZoneProps) => (
  <UploadAreaUI.ContentWrapper disabled={false} invalid={false} size="large" {...props}>
    <S.Container>
      <UploadAreaUI.Hero size="large" orientation="vertical">
        <S.Stack space={12}>
          <Icon component={PlusIcon} height={24} />
          <S.Stack space={8}>
            <S.Title>
              Drag and drop images or <u>browse</u>
            </S.Title>
            <S.Subtitle>Recommended 3:4 aspect ratio, at least 600px wide</S.Subtitle>
          </S.Stack>
        </S.Stack>
      </UploadAreaUI.Hero>
    </S.Container>
  </UploadAreaUI.ContentWrapper>
)

export const renderEmptyStateUploadZone = (props: EmptyStateUploadZoneProps) => (
  <EmptyStateUploadZone {...props} />
)
